<template>
  <center style="gap: 32px; display: flex; flex-wrap: wrap" class="payways">
    <button :class="{ active: method === 'lava' }" @click="set('lava')">
      <div class="head">Lava</div>
      <center>
        <img src="@/assets/pw-sbp.svg" class="pw-icon">
        <img src="@/assets/pw-qiwi.svg" class="pw-icon">
        <img src="@/assets/pw-card.svg" class="pw-icon">
        <img src="@/assets/pw-lava.svg" class="pw-icon">
      </center>
    </button>
    <button :class="{ active: method === 'primepayments' }" @click="set('primepayments')">
      <div class="head">PrimePayments</div>
      <center>
        <img src="@/assets/pw-card.svg" class="pw-icon">
        <img src="@/assets/pw-qiwi.svg" class="pw-icon">
        <img src="@/assets/pw-yoo_money.svg" class="pw-icon">
        <img src="@/assets/pw-btc.svg" class="pw-icon" >
      </center>
    </button>
    <button :class="{ active: method === 'nicepay' }" @click="set('nicepay')">
      <div class="head">Nicepay</div>
      <center>
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/sberbank.png" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/tinkoff.png" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/sbp.svg" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/qiwi.png" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/yoomoney.webp" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/alfabank.png" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/vtbbank.png" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/raiffeisen.webp" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/rnkbbank.png" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/postbank.png" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/avcash.jpg" class="pw-icon">
        <img src="https://nicepayio.s3.eu-central-1.amazonaws.com/icons/payment/payeer.png" class="pw-icon">
      </center>
    </button>
  </center>
</template>

<script>
  export default {
    data() {
      return {
        method: "nicepay"
      };
    },
    
    methods: {
      set(value) {
        this.method = value;
        this.$emit("method", value);
      }
    }
  }
</script>

<style lang="scss">
.payways {
  > button {
    &.active {
      border-color: #004455;
    }
    border: 2px solid rgba(0,0,0,0);
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    > center {
      display: flex;
      gap: 16px;
      justify-content: center;
    }
    > .head {
      font-size: 32px;
    }
  }
}

.pw-icon {
  width: 48px;
  height: 48px;
}
</style>
